module.exports = __webpack_public_path__ + "media/src/images/logos/adafruit-small-logo-81d32435a73b7d6427ffd9f429360f4c.png";